import { render, staticRenderFns } from "./ContactTagModal.vue?vue&type=template&id=62cba1c8&"
import script from "./ContactTagModal.vue?vue&type=script&lang=js&"
export * from "./ContactTagModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports